import { useEffect } from 'react';
import { Attention } from '@peacecover/icon';
import { t } from 'i18next';

const PaymentFailPage = () => {
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     window.close();
  //   }, 2000);

  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <div className="h-screen flex flex-col items-center justify-center gap-[17px]">
      <Attention size={82} className="text-on-warning" />
      <p className="text-[24px] font-semibold text-text-main-lv2 leading-[29px]">
        {t('Payment.fail')}
      </p>
    </div>
  );
};

export default PaymentFailPage;
